// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3nT6X","productName":"Table_productName__izKQU"};